"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "VictoryPie", {
  enumerable: true,
  get: function () {
    return _victoryPie.default;
  }
});
Object.defineProperty(exports, "Slice", {
  enumerable: true,
  get: function () {
    return _slice.default;
  }
});

var _victoryPie = _interopRequireDefault(require("./victory-pie"));

var _slice = _interopRequireDefault(require("./slice"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }


//////////////////
// WEBPACK FOOTER
// ./~/victory-pie/lib/index.js
// module id = 1893
// module chunks = 0